import { gql } from '@apollo/client';

export default gql`
  query bookingsWithMinors($period: String!, $stationUic: String!) {
    bookingsWithMinors(period: $period, stationUic: $stationUic) {
      reference
      status
      additionalDetails {
        key
        value
      }
      externalBookingReferences {
        source
        type
        externalId
      }
      customer {
        firstName
        lastName
      }
      passengers {
        id
      }
      outbound {
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
      }
      inbound {
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
      }
    }
  }
`;
